// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-recruiter",
 "roleDisplay": "AI Recruiter",
 "phrase": "ai recruiter",
 "seo": {
  "title": "AI Recruiter: Sources, Screens, Schedules | CellCog",
  "description": "An AI recruiter that sources candidates, screens every application against your real requirements, writes personal outreach and schedules the interviews."
 },
 "painSub": "The right candidate is in the pile somewhere, but reading 200 applications takes the week you don't have. Your AI recruiter reads every one against the role, ranks the shortlist with reasons, and keeps every candidate informed.",
 "definition": "An AI recruiter is an AI employee that sources candidates, screens applications against your job requirements, writes personal outreach and schedules interviews. On CellCog an AI recruiter is hired in minutes, works from your ATS or a spreadsheet, and researches each candidate's background with the agent ranked #1 on DeepResearch Bench (October 2026) before writing a word.",
 "panes": [
  {
   "num": "01 · SHORTLIST",
   "title": "Ranks every applicant.",
   "sub": "Each application is read against the role, with a short reason for every yes and no.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--table\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Shortlist</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Backend engineer shortlist</b><span>6 of 214 applications</span></div><div class=\"rf-panel\"><table class=\"rf-table\"><thead><tr><th scope=\"col\">Candidate</th><th scope=\"col\">Background</th><th scope=\"col\">Match</th><th scope=\"col\">Status</th></tr></thead><tbody><tr><td data-label=\"Candidate\">Priya Anand<span class=\"rf-sub\">Led a billing migration</span></td><td data-label=\"Background\">Payments, 6 yrs Go</td><td data-label=\"Match\">Strong</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-blue\">Outreach drafted</span></td></tr><tr><td data-label=\"Candidate\">Marcus Lee<span class=\"rf-sub\">Talks on idempotent APIs</span></td><td data-label=\"Background\">Payments API, Rust</td><td data-label=\"Match\">Strong</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-purple\">Take-home sent</span></td></tr><tr><td data-label=\"Candidate\">Sofia Reyes<span class=\"rf-sub\">Grew a platform team to 8</span></td><td data-label=\"Background\">Platform lead, Go</td><td data-label=\"Match\">Strong</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-green\">Interview Tue</span></td></tr><tr><td data-label=\"Candidate\">Tomas Weber<span class=\"rf-sub\">Wrote a caching layer at scale</span></td><td data-label=\"Background\">Queues and caching</td><td data-label=\"Match\">Good</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-graphite\">Screened</span></td></tr><tr><td data-label=\"Candidate\">Aiko Tanaka<span class=\"rf-sub\">Ledger services in Go</span></td><td data-label=\"Background\">Fintech backend</td><td data-label=\"Match\">Good</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-graphite\">Screened</span></td></tr><tr><td data-label=\"Candidate\">Liam Okafor<span class=\"rf-sub\">Strong data work, less API</span></td><td data-label=\"Background\">Data pipelines</td><td data-label=\"Match\">Maybe</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-amber\">Your call</span></td></tr></tbody></table><ul class=\"rf-tlist\"><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Priya Anand</b><span class=\"rf-chip rf-tone-blue\">Outreach drafted</span></div><span class=\"rf-tl-rest\">Payments, 6 yrs Go · Strong</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Marcus Lee</b><span class=\"rf-chip rf-tone-purple\">Take-home sent</span></div><span class=\"rf-tl-rest\">Payments API, Rust · Strong</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Sofia Reyes</b><span class=\"rf-chip rf-tone-green\">Interview Tue</span></div><span class=\"rf-tl-rest\">Platform lead, Go · Strong</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Tomas Weber</b><span class=\"rf-chip rf-tone-graphite\">Screened</span></div><span class=\"rf-tl-rest\">Queues and caching · Good</span></li></ul><div class=\"rf-tlist-more\"><p class=\"rf-sched-more\">and 2 more</p></div></div></div></div></div>"
  },
  {
   "num": "02 · OUTREACH",
   "title": "Writes to each candidate.",
   "sub": "Outreach that mentions something real from each person's background, one message at a time.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drafts\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drafts</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Personal outreach</b><span>Each one researched first</span></div><div class=\"rf-drafts\"><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/gmail.svg\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Marcus Lee</em></div><b class=\"rf-dr-s\">Your payments API talk</b><p>Hi Marcus, your talk on retrying payments without double charges covered the exact problem our billing team argues about every week. We are growing that team at Kestrel Loop. Open to a 15 minute chat?</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/gmail.svg\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Aiko Tanaka</em></div><b class=\"rf-dr-s\">Ledger services in Go</b><p>Hi Aiko, your Go work on ledger services is close to what we are building. We are hiring a backend engineer, remote in US time zones. Would you like the details?</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/gmail.svg\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Tomas Weber</em></div><b class=\"rf-dr-s\">Caching at scale</b><p>Hi Tomas, the caching layer you wrote about solves a problem we face every day. Could we find 15 minutes this week?</p></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers the role.",
   "sub": "Job descriptions, scorecards and past hires live in your Drive, so screening stays consistent.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Kestrel Loop</span><i aria-hidden=\"true\">/</i><b>Hiring</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Backend engineer role.docx</span><span class=\"rf-fmeta\">Must-haves and nice-to-haves</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Applicants.xlsx</span><span class=\"rf-fmeta\">214 applications, all read</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Interview scorecard.pdf</span><span class=\"rf-fmeta\">5 questions, scored 1 to 5</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Past offers</span><span class=\"rf-fmeta\">What a strong hire looked like</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Remote in US time zones, Go or Rust required, and every applicant hears back within 3 days.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before anyone is contacted.",
   "sub": "Outreach and rejections wait for your yes. Approve, edit or skip each one.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send this message to Priya Anand?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Priya Anand</em></div><b class=\"rf-prev-t\">Backend engineer role at Kestrel Loop</b><p class=\"rf-prev-b\">Hi Priya, your write-up on cutting queue latency in half caught my eye. We are hiring a backend engineer for our billing service. Open to a 15 minute call? Rae, AI recruiting assistant at Kestrel Loop</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Reply to Marcus Lee about the take-home</span><span class=\"rf-q-m\">Gmail · drafted</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Invite Sofia Reyes to interview</span><span class=\"rf-q-m\">Calendar · Tue 11:00</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Reports on the pipeline.",
   "sub": "Where each candidate stands, who is stuck and which decisions are waiting on you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Backend engineer hiring</b><span>Today, 5:40 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>214</b><span>applications read</span></div><div class=\"rf-stat\"><b>6</b><span>shortlisted</span></div><div class=\"rf-stat\"><b>2</b><span>interviews booked</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Screened 41 new applications against the role</li><li>Shortlisted 6, each with a written reason</li><li>Booked 2 interviews for Tuesday</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Send interviewer briefs for Tuesday</li><li>Reply to the 35 applicants not moving forward</li><li>Draft the offer letter template for your review</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Pick 3 of the 6 for first interviews</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Sources candidates",
   "body": "Searches for people who match the role and builds a ranked list with a fit note on each name."
  },
  {
   "title": "Screens every application",
   "body": "Reads each application against your written requirements and explains every yes and no."
  },
  {
   "title": "Writes personal outreach",
   "body": "References something real from each candidate's background, never a name token in a template."
  },
  {
   "title": "Schedules interviews",
   "body": "Proposes times from the calendars you connect, sends invites and interviewer briefs, reschedules when plans change."
  },
  {
   "title": "Prepares interview guides",
   "body": "Competencies, questions for each and what a strong answer sounds like, for every interviewer."
  },
  {
   "title": "Reports on the pipeline",
   "body": "Candidates per stage, where people drop off and how long each role has been open."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a recruiter. We need a senior backend engineer, remote, US time zones.\""
  },
  {
   "n": "02",
   "title": "Connect your hiring tools.",
   "body": "Add Greenhouse, Lever or a spreadsheet, plus your inbox and calendar."
  },
  {
   "n": "03",
   "title": "Approve the first shortlist.",
   "body": "They send a ranked shortlist with reasons. You pick who moves forward."
  }
 ],
 "tools": [
  {
   "name": "Greenhouse",
   "logo": "https://logos.composio.dev/api/greenhouse"
  },
  {
   "name": "Lever",
   "logo": "https://logos.composio.dev/api/lever"
  },
  {
   "name": "LinkedIn",
   "logo": "https://logos.composio.dev/api/linkedin"
  },
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Google Calendar",
   "logo": "https://logos.composio.dev/api/googlecalendar"
  },
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  },
  {
   "name": "Zoom",
   "logo": "https://logos.composio.dev/api/zoom"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  }
 ],
 "control": {
  "statement": "Nobody is contacted without your yes.",
  "sub": "They do the screening.",
  "accent": "You decide who moves forward.",
  "rows": [
   {
    "title": "Shortlists, never decides",
    "body": "They rank and explain; who to interview and hire stays your call."
   },
   {
    "title": "Outreach on your approval",
    "body": "Every message waits for your yes unless you approve a kind in advance."
   },
   {
    "title": "Reasons you can check",
    "body": "Every screening decision comes with a short written reason."
   }
  ]
 },
 "wont": {
  "sub": "They run your hiring pipeline.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No hiring decisions",
    "body": "They shortlist and explain; you decide who gets hired."
   },
   {
    "title": "No criteria you didn't set",
    "body": "They screen only against the requirements you give them and show their reasoning."
   },
   {
    "title": "No messages you haven't approved",
    "body": "Outreach waits for your yes unless you approve a kind of message in advance."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to fill a role",
  "cols": [
   "Doing it yourself",
   "A recruiting tool",
   "AI Recruiter"
  ],
  "rows": [
   {
    "label": "Reads every application",
    "cells": [
     "If time allows",
     "Keyword filters",
     "Yes, against your criteria"
    ]
   },
   {
    "label": "Explains each yes or no",
    "cells": [
     "No",
     "No",
     "A short written reason"
    ]
   },
   {
    "label": "Writes personal outreach",
    "cells": [
     "You",
     "Templates",
     "Researched, one to one"
    ]
   },
   {
    "label": "Schedules interviews",
    "cells": [
     "Email back and forth",
     "Booking links",
     "Proposes times, sends invites"
    ]
   },
   {
    "label": "Keeps the tracker current",
    "cells": [
     "You",
     "Partly",
     "After every step"
    ]
   },
   {
    "label": "Makes the hiring decision",
    "cells": [
     "You",
     "You",
     "You"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Here is the job description for our senior backend engineer role. Screen these 40 applications and give me a ranked shortlist with a two-line rationale for each of the top 10.",
   "deliverable": "a ranked, reasoned candidate shortlist"
  },
  {
   "q": "Source 20 candidates for our head of customer success role: SaaS background, 5+ years, US time zones. Include why each one fits.",
   "deliverable": "a sourced candidate list with fit notes"
  },
  {
   "q": "Write personalized outreach to these 10 candidates, referencing something real from their background. Keep each under 120 words.",
   "deliverable": "ten individually written outreach drafts"
  },
  {
   "q": "Draft a structured interview guide for this role: the competencies, questions for each, and what a strong answer sounds like.",
   "deliverable": "a structured interview guide"
  },
  {
   "q": "Give me a pipeline report: candidates per stage, conversion between stages and where candidates drop off.",
   "deliverable": "a hiring pipeline report"
  }
 ],
 "faq": [
  {
   "q": "What is an AI recruiter?",
   "a": "An AI recruiter is an AI employee that sources candidates, screens applications against your job requirements, writes personal outreach and schedules interviews."
  },
  {
   "q": "Do they work with our ATS?",
   "a": "Yes, they connect to Greenhouse, Lever and other tools from our catalog of 1,500+. If you hire from a spreadsheet and an inbox, they work there too."
  },
  {
   "q": "How do they screen applications?",
   "a": "Against the requirements you write down. Every yes or no comes with a short written reason, so you can check their judgment and change the criteria in one message."
  },
  {
   "q": "Who makes the hiring decision?",
   "a": "You do. They build the shortlist and the evidence; who to interview and who to hire stays your call."
  },
  {
   "q": "Will candidates know they are hearing from an AI?",
   "a": "Yes. Your AI recruiter writes under their own name as your AI recruiting assistant, and their messages read well because they researched each person first."
  },
  {
   "q": "Can they schedule interviews?",
   "a": "Yes. They propose times from the calendars you connect, send the invites and interviewer briefs, and reschedule when plans change."
  },
  {
   "q": "Are they an AI recruiter agent or an AI recruiting assistant?",
   "a": "Both words fit. They work as a recruiting assistant inside your process: they source, screen, write outreach and schedule interviews, and you make every hiring decision."
  },
  {
   "q": "Can an AI recruiter call candidates?",
   "a": "Yes. Give your AI recruiter their own phone number and, once your business is verified, they can call applicants who applied for your role. Your AI recruiter tells them they are speaking with an AI and reports back on each call."
  },
  {
   "q": "Can I try an AI recruiter for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI recruiter and try a first task."
  },
  {
   "q": "What does an AI recruiter cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Recruiter in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Recruiter to work today",
  "body": "Give them a job description and get back a sourced shortlist with fit notes and outreach drafts."
 },
 "audience": {
  "title": "Who hires an AI recruiter",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Hiring without a talent team",
    "body": "Sourcing, screening and scheduling handed off, so their hiring time goes to candidates worth meeting."
   },
   {
    "badge": "Small businesses",
    "title": "A real process for every role",
    "body": "Consistent screening against your criteria and candidates who never go cold, even when hiring is nobody's full-time job."
   },
   {
    "badge": "Mid-size companies",
    "title": "Every open role covered",
    "body": "Each hiring manager gets sourcing, screening and scheduling for their roles, with one consistent process across teams."
   },
   {
    "badge": "Agencies",
    "title": "More searches in parallel",
    "body": "Recruiting agencies and fractional talent partners run more searches at once, with researched screening on every one."
   },
   {
    "badge": "Startups hiring engineers",
    "title": "Technical roles screened with care",
    "body": "Every application ranked against your requirements with a short reason, so engineers only interview the strongest."
   },
   {
    "badge": "High-volume hiring",
    "title": "Every application read",
    "body": "Stores, restaurants and warehouses get every application read against the same criteria and interviews booked quickly."
   }
  ]
 }
};

export default content;
